<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM KỲ THI</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-text-field
            label="Tên kỳ thi"
            v-model="name"
            outlined
            required
            :rules="[$rules.required]"
            class="required"
          ></v-text-field>
          <v-select
            label="Loại thi"
            :items="typeOptions"
            item-text="label"
            item-value="value"
            v-model="type"
            outlined
            :rules="[$rules.required]"
            class="required"
          ></v-select>
          <!-- <v-select
            label="Phúc khảo"
            :items="reviewOptions"
            item-text="label"
            item-value="value"
            v-model="gradeReview"
            outlined
            :rules="[$rules.required]"
            class="required"
          ></v-select> -->
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Ngày"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable @input="menu = false" />
          </v-menu>
          <v-text-field
            label="Địa điểm"
            v-model="location"
            outlined
            required
            :rules="[$rules.required]"
            class="required pt-6"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    state: Boolean
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      grade: '',
      type: '',
      //   gradeReview: 'true',
      date: '',
      location: '',
      phase: '',
      menu: false,
      typeOptions: [
        { label: 'Cuối kỳ', value: 'final' },
        { label: 'Giữa kỳ', value: 'midTerm' },
        { label: 'Thi khác', value: 'extra' }
      ],
      reviewOptions: [
        { label: 'Có', value: 'true' },
        { label: 'Không', value: 'false' }
      ]
    }
  },
  methods: {
    ...mapActions('exam', ['createExam']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        let data = {
          name: this.name,
          grade: this.grade,
          type: this.type,
          //   gradeReview: this.gradeReview,
          startDate: this.date,
          location: this.location,
          status: 'active',
          phase: this.phase
        }
        const createExam = await this.createExam({ ...data })

        if (createExam) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        } else {
          this.$alert.error('Lỗi tạo sản phẩm')
        }
      }
    },
    resetForm() {
      this.name = ''
      this.acronym = ''
      this.grade = ''
      this.note = ''
      this.type = ''
      this.phase = ''
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
